import { AwsConfig } from './Constants';
import BasePaginationQuery from '../interfaces/base-pagination-query';
import BaseService, { RequestInterface } from './Base';
import IPagination from '../interfaces/IPagination';
import { graphqlOperation} from 'aws-amplify';
import { StatusProcess } from '@helpers/Enums';


export default class UserGroupService extends BaseService {

  constructor(){
    super(AwsConfig.API_CONFIG, 'graphql');
  }

  async create(data: any): Promise<any> {
    const { title, from, to, processId, groupId } = data
    const graphQlBody = {
      "query": `mutation{putSchedule(data: {title: \"${title}\" from: \"${from}\" to: \"${to}\" processId: \"${processId}\" groupId: \"${groupId}\"}){id}}`
    }
    const params: RequestInterface = {
        body: graphQlBody
    };
    const res = await super.post<any>('', params);
    return res;
  }

  async listAll(){
    
    //REFACTOR! 
    const graphqlBody = {
      "query": "{listSchedules{id title status groupId processId from to process} }"
    }
    const params: RequestInterface = {
        body:graphqlBody
    };
    const res = await super.post('', params);
    return res
  }

  async getScheduleByUser(id: string, status: StatusProcess[]) {
    
    const getSchedulesByUser = `query getSchedulesByUser($id: String! $status: [Int!]!) {
      getSchedulesByUser(id: $id status: $status) {
        id
        title
        processId
        process
        to
        from
        groupId
        createAt
        clientId
        status
        tags
      }
    }`;

    const query = graphqlOperation(getSchedulesByUser, {id, status});

    const params: RequestInterface = {
      body: query
    }

    const res = await super.postGraphQl('', params);

    return res;
  }

  async getSchedule(id: string, status: StatusProcess[]) {
    
    const getSchedules = `query($id: String!) {
      getSchedules(id: $id) {
        id
        status
      }
    }`;

    const query = graphqlOperation(getSchedules, {id});

    const params: RequestInterface = {
      body: query
    }

    const res = await super.postGraphQl('', params);
    return res;
  }

  async editSchedule(id: string, data: any): Promise<any> {
    const editSchedule = `mutation updateSchedule($filter: ScheduleFilter! $data: ScheduleInput!) {
      updateSchedule(filter: $filter data: $data) {
        id
        status
      }
    }`;

    const newData = Object.assign({}, data, {title: data.realName})
    delete newData.realName;
    delete newData.allday;

    const variables = {
      filter: { id },
      data: newData
    }
    
    const query = graphqlOperation(editSchedule, {filter: variables.filter, data: variables.data})
  
    const params: RequestInterface = {
      body: query
    };
    const res = await super.post<any>('', params);
    return res;
  }

  async deleteSchedule(id: string): Promise<void> {
    const graphQlBody = {
      "query": `mutation{deleteSchedule(id: \"${id}\"){id title}}`
    }
    const params: RequestInterface = {
      body: graphQlBody
    }
    
    const res = await super.post<any>('', params);
    return res;
  }


  async paging(query: BasePaginationQuery, fields?: string[]): Promise<IPagination<any>> {
    const params: RequestInterface = {
      queryStringParameters: super.setFields(fields)
    };
    if (query.unit) {
      params.queryStringParameters['unit'] = query.unit;
    }
    if (query.notUnit) {
      params.queryStringParameters['notUnit'] = query.notUnit;
    }
    if (query.notRole) {
      params.queryStringParameters['notRole'] = query.notRole;
    }
    if (query.haveManager) {
      params.queryStringParameters['haveManager'] = query.haveManager;
    }
    if (query.hasRole) {
      params.queryStringParameters['hasRole'] = query.hasRole;
    }
    if (query.pillar) {
      params.queryStringParameters['pillar'] = query.pillar;
    }
    if (query.limit) {
      params.queryStringParameters['limit'] = query.limit;
    }
    if (query.offset) {
      params.queryStringParameters['offset'] = query.offset;
    }
    if (query.disabled != null) {
      params.queryStringParameters['disabled'] = query.disabled;
    }
    if (query.search) {
      params.queryStringParameters['search'] = query.search;
    }
    if (query.noAuditor) {
      params.queryStringParameters['noAuditor'] = query.noAuditor;
    }
    if (query.noAudited) {
      params.queryStringParameters['noAudited'] = query.noAudited;
    }
    if (query.noAssignment) {
      params.queryStringParameters['noAssignment'] = query.noAssignment;
    }
    if (query.isManager != null) {
      params.queryStringParameters['isManager'] = query.isManager;
    }

    const res = await super.get<IPagination<any>>('', params);
    return res;
  }
}

